export const translations = {
  nav: {
    home: { fr: 'Accueil', en: 'Home' },
    about: { fr: 'Qui Sommes-Nous', en: 'About Us' },
    approach: { fr: 'Notre Philosophie', en: 'Our Philosophy' },
    activities: { fr: 'Activités', en: 'Activities' },
    investments: { fr: 'Investissements', en: 'Investments' },
    team: { fr: 'Équipe', en: 'Team' },
    news: { fr: 'Actualités', en: 'News' },
    contact: { fr: 'Contact', en: 'Contact' },
    legal: { fr: 'Mentions légales', en: 'Legal' }
  },
  common: {
    tagline: {
      fr: 'Into the Depths, Beyond the Expected.',
      en: 'Into the Depths, Beyond the Expected.'
    },
    learnMore: {
      fr: 'En savoir plus',
      en: 'Learn more'
    }
  },
  home: {
    hero: {
      headline: {
        fr: 'Capital et accompagnement de long terme pour les entreprises industrielles critiques en Europe.',
        en: 'Long-term capital and hands-on partnership for critical industrial businesses across Europe.'
      },
      subheading: {
        fr: 'Investir et accompagner. En profondeur et dans la durée, aux côtés des dirigeants industriels.',
        en: 'We invest and we operate. Deep inside the business and over the long run, alongside Europe\'s industrial leaders.'
      },
      cta1: {
        fr: 'Découvrir notre approche',
        en: 'Discover our approach'
      },
      cta2: {
        fr: 'Voir les investissements',
        en: 'See our investments'
      }
    },
    activities: {
      title: {
        fr: 'Nos activités',
        en: 'Our activities'
      },
      fund: {
        title: {
          fr: 'Investissements fonds',
          en: 'Fund investments'
        },
        description: {
          fr: 'Nous investissons dans des entreprises industrielles européennes positionnées sur des marchés de niche stratégiques, dotées d\'un savoir-faire technique reconnu et d\'un potentiel de développement.',
          en: 'We invest in European industrial companies positioned in strategic niche markets, with recognised technical expertise and growth potential that only deep, hands-on engagement can unlock.'
        }
      },
      support: {
        title: {
          fr: 'Accompagnement & création de valeur',
          en: 'Support & value creation'
        },
        description: {
          fr: 'Nous accompagnons les entreprises dans leur transformation opérationnelle : stabilisation des flux, renforcement des fondamentaux, amélioration de la performance.',
          en: 'We support businesses through operational transformation: stabilising workflows, reinforcing fundamentals, and improving performance.'
        }
      },
      holding: {
        title: {
          fr: 'Holding industriel (Moret)',
          en: 'Industrial holding (Moret)'
        },
        description: {
          fr: 'Moret Industries est une plateforme diversifiée visant à acquérir et développer sur le long terme des OEM de niche dans l\'écosystème industriel.',
          en: 'Moret Industries is a diversified platform focused on acquiring and developing niche OEMs within the industrial ecosystem over the long term.'
        }
      }
    },
    mission: {
      title: {
        fr: 'Notre mission',
        en: 'Our mission'
      },
      description: {
        fr: 'Investir pour transformer durablement l\'industrie. Construire des champions industriels à l\'échelle mondiale.',
        en: 'Investing to create lasting industrial transformation. Building world-class industrial champions.'
      },
      metric1: {
        fr: '6 sociétés en portefeuille',
        en: '6 portfolio companies'
      },
      metric2: {
        fr: '9 pays',
        en: '9 countries'
      },
      metric3: {
        fr: '4 secteurs cibles',
        en: '4 target sectors'
      }
    },
    companies: {
      title: {
        fr: 'Nos investissements',
        en: 'Our investments'
      }
    },
    cta: {
      text: {
        fr: 'Découvrez notre approche et contactez notre équipe.',
        en: 'Discover our approach and get in touch with our team.'
      },
      button1: {
        fr: 'Découvrir notre approche',
        en: 'Discover our approach'
      },
      button2: {
        fr: 'Nous contacter',
        en: 'Contact us'
      }
    }
  },
  footer: {
    tagline: {
      fr: 'Into the Depths, Beyond the Expected.',
      en: 'Into the Depths, Beyond the Expected.'
    },
    description: {
      fr: 'Partenaire de transformation industrielle',
      en: 'Industrial investment partnership'
    },
    rights: {
      fr: '© 2026 Ocean Peak Group. Tous droits réservés.',
      en: '© 2026 Ocean Peak Group. All rights reserved.'
    }
  }
};